import React from "react";
import styles from "./approve-deny-button.module.scss";
import cn from "../../../../../Utils/class-names.utils";

export const ApproveDenyButton = ({ isApprove = true, onClick }) => {
  return (
    <button
      type="button"
      className={cn(
        styles.button,
        isApprove ? styles.buttonApprove : styles.buttonDeny
      )}
      aria-label={isApprove ? "Approve" : "Deny"}
      onClick={onClick}
    >
      <div className={styles.buttonInner}>
        <span className={cn(
          styles.buttonText,
          isApprove ? styles.textApprove : styles.textDeny
        )}>
          {isApprove ? "Approve" : "Deny"}
        </span>
      </div>
    </button>
  );
};

